module.exports = __webpack_public_path__ + "assets/fonts/Guroo-Producer.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/guroo-producer/fonts/Guroo-Producer.eot
 ** module id = 356
 ** module chunks = 0
 **/